import { useEffect, useState } from "react";
import { notify } from "../components/UI/notify";
import { NotifyType } from "../types/enums/notifytype";
import api from "./api";


    const { message } = notify();
   
export const handleSequenceChange = (e) => {
        const value = Number(e.target.value);
        if (value < 0) {
            message(NotifyType.Error, "Negative numbers are not allowed!");
            e.target.value = "";
          return; // Prevents updating state
        }
        if (value > 12) {
          message(NotifyType.Error, "Max Running number should be less than 13");
          e.target.value = "";
        return; // Prevents updating state
      }
        
      };
      export const handleNegativeChange = (e) => {
        const value = Number(e.target.value);
        if (value < 0) {
            message(NotifyType.Error, "Negative numbers are not allowed!");
            e.target.value = "";
          return; // Prevents updating state
        }
      
        
      };

      export     const disableScroll = () => {
        document.body.style.overflow = "hidden";
      };
      
      export    const enableScroll = () => {
        document.body.style.overflow = "";
        document.documentElement.style.overflow = "auto";
      };

 export const getMaxChars = () => {
  const scale = window.devicePixelRatio;
  if (scale >= 1.75) return 8; // 175% or higher
  if (scale >= 1.5) return 13;  // 150%
  if (scale >= 1.25) return 21; // 125%
  return 23;                    // 100% scale (default)
};

/**
 * Hook: Dynamically updates maxChars when display scale changes
 */
export const useResponsiveMaxChars = () => {
  const [maxChars, setMaxChars] = useState(getMaxChars());

  useEffect(() => {
    const handleChange = () => setMaxChars(getMaxChars());

    // Detect zoom or scale changes
    window.addEventListener("resize", handleChange);

    // Extra safety: check every 500ms in case browser doesn’t fire resize
    const interval = setInterval(() => {
      const current = getMaxChars();
      setMaxChars((prev) => (prev !== current ? current : prev));
    }, 500);

    return () => {
      window.removeEventListener("resize", handleChange);
      clearInterval(interval);
    };
  }, []);

  return maxChars;
};

export const getDynamicMaxChars = () => {
  const width = window.innerWidth;
  const scale = window.devicePixelRatio || 1;
  let baseChars;

  // Step 1: Base by resolution
  if (width >= 1920) baseChars = 170; // 1080p+
  else if (width >= 1600) baseChars = 142;
  else if (width >= 1440) baseChars = 129;
  else if (width >= 1366) baseChars = 115;
  else if (width >= 1280) baseChars = 104;
  else if (width >= 1024) baseChars = 90;
  else if (width >= 768)  baseChars = 77;
  else baseChars = 60;

  // Step 2: Fine-tune by zoom / scale (each scale has tailored behavior)
  const scaleAdjustments = {
    "0.75": 1.15,  // zoomed out
    "0.9": 1.08,
    "1": 1.0,
    "1.25": 0.93,
    "1.5": 0.89,
    "1.75": 0.78,
    "2": 0.68,
    "2.5": 0.6
  };

  const nearestScale = Object.keys(scaleAdjustments)
    .map(Number)
    .reduce((prev, curr) =>
      Math.abs(curr - scale) < Math.abs(prev - scale) ? curr : prev
    );

  baseChars = Math.floor(baseChars * scaleAdjustments[nearestScale]);
  return baseChars;
};




export const useDynamicResponsiveChars = () => {
  const [maxChars, setMaxChars] = useState(getDynamicMaxChars());

  useEffect(() => {
    let timeout;

    const handleResizeOrZoom = () => {
      clearTimeout(timeout);
      timeout = setTimeout(() => {
        setMaxChars(getDynamicMaxChars());
      }, 200);
    };

    window.addEventListener("resize", handleResizeOrZoom);

    // Re-check every second for browsers that don't trigger resize on zoom
    const interval = setInterval(() => {
      const newChars = getDynamicMaxChars();
      setMaxChars((prev) => (prev !== newChars ? newChars : prev));
    }, 1000);

    return () => {
      window.removeEventListener("resize", handleResizeOrZoom);
      clearInterval(interval);
    };
  }, []);

  return maxChars;
};


export const getDashboardMaxCharsDash = () => {
  const width = window.innerWidth;
  const scale = window.devicePixelRatio || 1;
  let baseChars;

  // Step 1: Base by resolution (capped for dashboard)
  if (width >= 1920) baseChars = 90;
  else if (width >= 1600) baseChars = 80;
  else if (width >= 1440) baseChars = 72;
  else if (width >= 1366) baseChars = 65;
  else if (width >= 1280) baseChars = 60;
  else if (width >= 1024) baseChars = 52;
  else if (width >= 768)  baseChars = 45;
  else baseChars = 35;

  // Step 2: Fine-tune by zoom / scale
  const scaleAdjustments = {
    "0.75": 1.15,  // zoomed out
    "0.9": 1.08,
    "1": 1.0,
    "1.25": 0.93,
    "1.5": 0.87,
    "1.75": 0.78,
    "2": 0.68,
    "2.5": 0.6
  };

  const nearestScale = Object.keys(scaleAdjustments)
    .map(Number)
    .reduce((prev, curr) => Math.abs(curr - scale) < Math.abs(prev - scale) ? curr : prev);

  return Math.floor(baseChars * scaleAdjustments[nearestScale]);
};



export const useDynamicResponsiveCharsDash = () => {
  const [maxCharsDash, setMaxCharsDash] = useState(getDashboardMaxCharsDash());

  useEffect(() => {
    let timeout;

    const handleResizeOrZoom = () => {
      clearTimeout(timeout);
      timeout = setTimeout(() => {
        setMaxCharsDash(getDashboardMaxCharsDash());
      }, 200);
    };

    window.addEventListener("resize", handleResizeOrZoom);

    // Re-check every second for browsers that don't trigger resize on zoom
    const interval = setInterval(() => {
      const newChars = getDashboardMaxCharsDash();
      setMaxCharsDash((prev) => (prev !== newChars ? newChars : prev));
    }, 1000);

    return () => {
      window.removeEventListener("resize", handleResizeOrZoom);
      clearInterval(interval);
    };
  }, []);

  return maxCharsDash;
};
  
export const getTruncatedText = (text, maxCharsDash) => {
  if (!text) return "";
  if (text.length <= maxCharsDash) return text;
  return `${text.substring(0, maxCharsDash)}...`;
};



export const getMaxCharsDrop = () => {
  const scale = window.devicePixelRatio;
  if (scale >= 1.75) return 40; // 175% or higher
  if (scale >= 1.5) return 29;  // 150%
  if (scale >= 1.25) return 44; // 125%
  return 38;                    // 100% scale (default)
};

/**
 * Hook: Dynamically updates maxChars when display scale changes
 */
export const useResponsiveMaxCharsDrop = () => {
  const [maxChars, setMaxChars] = useState(getMaxCharsDrop());

  useEffect(() => {
    const handleChange = () => setMaxChars(getMaxCharsDrop());

    // Detect zoom or scale changes
    window.addEventListener("resize", handleChange);

    // Extra safety: check every 500ms in case browser doesn’t fire resize
    const interval = setInterval(() => {
      const current = getMaxCharsDrop();
      setMaxChars((prev) => (prev !== current ? current : prev));
    }, 500);

    return () => {
      window.removeEventListener("resize", handleChange);
      clearInterval(interval);
    };
  }, []);

  return maxChars;
};
export const handlePaste = (
  e: React.ClipboardEvent<HTMLTextAreaElement>,
  setValue: React.Dispatch<React.SetStateAction<string>>,
  maxLength: number = 500 // ✅ configurable limit
) => {
  e.preventDefault();

  let text = e.clipboardData.getData("text/plain") || "";

  if (!text) {
    const html = e.clipboardData.getData("text/html");
    if (html) {
      text = html
        .replace(/<style[^>]*>[\s\S]*?<\/style>/gi, "")
        .replace(/<meta[^>]*>/gi, "")
        .replace(/<o:p>|<\/o:p>/gi, "")
        .replace(/<!--[\s\S]*?-->/gi, "")
        .replace(/<[^>]+>/g, "")
        .replace(/\r\n|\r|\n/g, "\n")
        .trim();
    }
  }

  // ✅ Handle Excel cell data - convert tabs to spaces
  if (text.includes('\t')) {
    text = text
      .split('\n')
      .map(line =>
        line.includes('\t')
          ? line.split('\t').map(cell => cell.trim()).join('  ')
          : line
      )
      .join('\n');
  }

  const originalText = text;
  if (text) text = text.replace(/""/g, '"').replace(/^"+|"+$/g, "");
  if (text) text = text.replace(/[\u200B-\u200D\uFEFF]/g, "").trim();
  if (!text) text = originalText;

  const textarea = e.target as HTMLTextAreaElement;
  const start = textarea.selectionStart;
  const end = textarea.selectionEnd;

  setValue(prev => {
    const availableSpace =
      maxLength - (prev.length - (end - start));

    if (availableSpace <= 0) {
      return prev; // ❌ No space left
    }

    const trimmedText = text.slice(0, availableSpace);

    return (
      prev.slice(0, start) +
      trimmedText +
      prev.slice(end)
    );
  });

  // ✅ Update cursor position correctly
  setTimeout(() => {
    const pastedLength = Math.min(text.length, maxLength);
    textarea.selectionStart = textarea.selectionEnd =
      start + pastedLength;
  }, 0);
};


export const handlePasteReference = (
  e: React.ClipboardEvent<HTMLTextAreaElement>,
  callback: (value: string) => void
) => {
  e.preventDefault();

  let text = e.clipboardData.getData("text/plain") || "";

  if (!text) {
    const html = e.clipboardData.getData("text/html");
    if (html) {
      text = html
        .replace(/<style[^>]*>[\s\S]*?<\/style>/gi, "")
        .replace(/<meta[^>]*>/gi, "")
        .replace(/<o:p>|<\/o:p>/gi, "")
        .replace(/<!--[\s\S]*?-->/gi, "")
        .replace(/<[^>]+>/g, "")
        .replace(/\r\n|\r|\n/g, "\n")
        .trim();
    }
  }

  if (text.includes("\t")) {
    const lines = text.split("\n");
    text = lines
      .map((line) => {
        if (line.includes("\t")) {
          return line
            .split("\t")
            .map((cell) => cell.trim())
            .join("  ");
        }
        return line;
      })
      .join("\n");
  }

  const originalText = text;
  if (text) text = text.replace(/""/g, '"').replace(/^"+|"+$/g, "");
  if (text) text = text.replace(/[\u200B-\u200D\uFEFF]/g, "").trim();
  if (!text) text = originalText;

  const textarea = e.target as HTMLTextAreaElement;
  const start = textarea.selectionStart;
  const end = textarea.selectionEnd;

  const finalValue = textarea.value.slice(0, start) + text + textarea.value.slice(end);

  // 👇 Send back final processed text
  callback(finalValue);

  // cursor update
  setTimeout(() => {
     autoResizeTextarea(textarea);
    textarea.selectionStart = textarea.selectionEnd = start + text.length;
  }, 0);
};

const autoResizeTextarea = (textarea: HTMLTextAreaElement) => {
  textarea.style.height = "auto";
  textarea.style.height = textarea.scrollHeight + "px";
};






